module.exports = __webpack_public_path__ + "img/fSwcJQtx.0714f2e7.svg";